import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=32d50200&scoped=true&"
import script from "./Control.vue?vue&type=script&lang=js&"
export * from "./Control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d50200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d50200')) {
      api.createRecord('32d50200', component.options)
    } else {
      api.reload('32d50200', component.options)
    }
    module.hot.accept("./Control.vue?vue&type=template&id=32d50200&scoped=true&", function () {
      api.rerender('32d50200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/lFComponents/Control.vue"
export default component.exports